import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  KpiCategories,
  KpiKeys,
  KpisByCategory,
  KpisByKey,
  MilestoneName,
  StageName
} from '@models';

@Component({
  selector: 'kpis',
  templateUrl: './kpis.component.html',
  styleUrl: './kpis.component.scss'
})
export class KpisComponent implements OnChanges {
  @Input() kpisByCategory!: KpisByCategory;
  @Input() selectedKpiKey?: KpiKeys;
  @Input() expandedGanttChartStages?: StageName[];
  @Input() keyMilestones?: MilestoneName[];
  @Output() kpiCardClicked = new EventEmitter<KpiKeys>();

  tooltipsEnabled = true;
  kpisByCategoryArray!: { category: KpiCategories; kpis: KpisByKey }[];
  titleStages?: string;
  private STAGE_ORDER: StageName[] = ['Startup', 'Enrollment', 'Maintenance', 'Closeout'];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['kpisByCategory']) {
      this.kpisByCategoryArray = Object.entries(this.kpisByCategory).map(([category, kpis]) => ({
        category: category as KpiCategories,
        kpis: kpis as KpisByKey
      }));
    }

    if (changes['expandedGanttChartStages']) {
      this.setKpisTitle();
    }
  }

  onKpiCardClicked(kpiKey: KpiKeys) {
    this.kpiCardClicked.emit(kpiKey);
  }

  private setKpisTitle() {
    const stages = this.expandedGanttChartStages ?? [];
    if (stages.length && stages.length < this.STAGE_ORDER.length) {
      this.titleStages = ` — ${this.getStagesInTheCorrectOrder().join(', ')}`;
    } else {
      this.titleStages = undefined;
    }
  }

  private getStagesInTheCorrectOrder(): StageName[] {
    return this.STAGE_ORDER.filter((orderedStage) =>
      this.expandedGanttChartStages?.includes(orderedStage)
    );
  }
}
